/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { ApplicationQuoteResponseBaseResponse as ModelsV3ApplicationApplicationQuoteResponseBaseResponse } from '../models/Models/v3/Application/application-quote-response-base-response';
import { ApplicationSyncRequestBaseResponse as ModelsV3ApplicationApplicationSyncRequestBaseResponse } from '../models/Models/v3/Application/application-sync-request-base-response';
import { DtoInsuranceProductListBaseResponse as ModelsV3InsuranceDtoInsuranceProductListBaseResponse } from '../models/Models/v3/Insurance/dto-insurance-product-list-base-response';
import { DtoVehicleBaseResponse as ModelsV4VehicleDtoVehicleBaseResponse } from '../models/Models/v4/Vehicle/dto-vehicle-base-response';
import { v4ApplicationsApplicationIdInsuranceProductsPost$Json$Json } from '../fn/applications/v-4-applications-application-id-insurance-products-post-json-json';
import { V4ApplicationsApplicationIdInsuranceProductsPost$Json$Json$Params } from '../fn/applications/v-4-applications-application-id-insurance-products-post-json-json';
import { v4ApplicationsApplicationIdInsuranceProductsPost$Json$Plain } from '../fn/applications/v-4-applications-application-id-insurance-products-post-json-plain';
import { V4ApplicationsApplicationIdInsuranceProductsPost$Json$Plain$Params } from '../fn/applications/v-4-applications-application-id-insurance-products-post-json-plain';
import { v4ApplicationsApplicationIdInsuranceProductsPost$Json$Xml } from '../fn/applications/v-4-applications-application-id-insurance-products-post-json-xml';
import { V4ApplicationsApplicationIdInsuranceProductsPost$Json$Xml$Params } from '../fn/applications/v-4-applications-application-id-insurance-products-post-json-xml';
import { v4ApplicationsApplicationIdInsuranceProductsPost$Xml$Json } from '../fn/applications/v-4-applications-application-id-insurance-products-post-xml-json';
import { V4ApplicationsApplicationIdInsuranceProductsPost$Xml$Json$Params } from '../fn/applications/v-4-applications-application-id-insurance-products-post-xml-json';
import { v4ApplicationsApplicationIdInsuranceProductsPost$Xml$Plain } from '../fn/applications/v-4-applications-application-id-insurance-products-post-xml-plain';
import { V4ApplicationsApplicationIdInsuranceProductsPost$Xml$Plain$Params } from '../fn/applications/v-4-applications-application-id-insurance-products-post-xml-plain';
import { v4ApplicationsApplicationIdInsuranceProductsPost$Xml$Xml } from '../fn/applications/v-4-applications-application-id-insurance-products-post-xml-xml';
import { V4ApplicationsApplicationIdInsuranceProductsPost$Xml$Xml$Params } from '../fn/applications/v-4-applications-application-id-insurance-products-post-xml-xml';
import { v4ApplicationsApplicationIdInsuranceQuotePost$Json$Json } from '../fn/applications/v-4-applications-application-id-insurance-quote-post-json-json';
import { V4ApplicationsApplicationIdInsuranceQuotePost$Json$Json$Params } from '../fn/applications/v-4-applications-application-id-insurance-quote-post-json-json';
import { v4ApplicationsApplicationIdInsuranceQuotePost$Json$Plain } from '../fn/applications/v-4-applications-application-id-insurance-quote-post-json-plain';
import { V4ApplicationsApplicationIdInsuranceQuotePost$Json$Plain$Params } from '../fn/applications/v-4-applications-application-id-insurance-quote-post-json-plain';
import { v4ApplicationsApplicationIdInsuranceQuotePost$Json$Xml } from '../fn/applications/v-4-applications-application-id-insurance-quote-post-json-xml';
import { V4ApplicationsApplicationIdInsuranceQuotePost$Json$Xml$Params } from '../fn/applications/v-4-applications-application-id-insurance-quote-post-json-xml';
import { v4ApplicationsApplicationIdInsuranceQuotePost$Xml$Json } from '../fn/applications/v-4-applications-application-id-insurance-quote-post-xml-json';
import { V4ApplicationsApplicationIdInsuranceQuotePost$Xml$Json$Params } from '../fn/applications/v-4-applications-application-id-insurance-quote-post-xml-json';
import { v4ApplicationsApplicationIdInsuranceQuotePost$Xml$Plain } from '../fn/applications/v-4-applications-application-id-insurance-quote-post-xml-plain';
import { V4ApplicationsApplicationIdInsuranceQuotePost$Xml$Plain$Params } from '../fn/applications/v-4-applications-application-id-insurance-quote-post-xml-plain';
import { v4ApplicationsApplicationIdInsuranceQuotePost$Xml$Xml } from '../fn/applications/v-4-applications-application-id-insurance-quote-post-xml-xml';
import { V4ApplicationsApplicationIdInsuranceQuotePost$Xml$Xml$Params } from '../fn/applications/v-4-applications-application-id-insurance-quote-post-xml-xml';
import { v4ApplicationsApplicationIdNotifyDealerPost } from '../fn/applications/v-4-applications-application-id-notify-dealer-post';
import { V4ApplicationsApplicationIdNotifyDealerPost$Params } from '../fn/applications/v-4-applications-application-id-notify-dealer-post';
import { v4ApplicationsApplicationIdPut$Json$Json } from '../fn/applications/v-4-applications-application-id-put-json-json';
import { V4ApplicationsApplicationIdPut$Json$Json$Params } from '../fn/applications/v-4-applications-application-id-put-json-json';
import { v4ApplicationsApplicationIdPut$Json$Plain } from '../fn/applications/v-4-applications-application-id-put-json-plain';
import { V4ApplicationsApplicationIdPut$Json$Plain$Params } from '../fn/applications/v-4-applications-application-id-put-json-plain';
import { v4ApplicationsApplicationIdPut$Json$Xml } from '../fn/applications/v-4-applications-application-id-put-json-xml';
import { V4ApplicationsApplicationIdPut$Json$Xml$Params } from '../fn/applications/v-4-applications-application-id-put-json-xml';
import { v4ApplicationsApplicationIdPut$Xml$Json } from '../fn/applications/v-4-applications-application-id-put-xml-json';
import { V4ApplicationsApplicationIdPut$Xml$Json$Params } from '../fn/applications/v-4-applications-application-id-put-xml-json';
import { v4ApplicationsApplicationIdPut$Xml$Plain } from '../fn/applications/v-4-applications-application-id-put-xml-plain';
import { V4ApplicationsApplicationIdPut$Xml$Plain$Params } from '../fn/applications/v-4-applications-application-id-put-xml-plain';
import { v4ApplicationsApplicationIdPut$Xml$Xml } from '../fn/applications/v-4-applications-application-id-put-xml-xml';
import { V4ApplicationsApplicationIdPut$Xml$Xml$Params } from '../fn/applications/v-4-applications-application-id-put-xml-xml';
import { v4ApplicationsApplicationIdVehicleGet$Json } from '../fn/applications/v-4-applications-application-id-vehicle-get-json';
import { V4ApplicationsApplicationIdVehicleGet$Json$Params } from '../fn/applications/v-4-applications-application-id-vehicle-get-json';
import { v4ApplicationsApplicationIdVehicleGet$Plain } from '../fn/applications/v-4-applications-application-id-vehicle-get-plain';
import { V4ApplicationsApplicationIdVehicleGet$Plain$Params } from '../fn/applications/v-4-applications-application-id-vehicle-get-plain';
import { v4ApplicationsApplicationIdVehicleGet$Xml } from '../fn/applications/v-4-applications-application-id-vehicle-get-xml';
import { V4ApplicationsApplicationIdVehicleGet$Xml$Params } from '../fn/applications/v-4-applications-application-id-vehicle-get-xml';
import { v4ApplicationsVehicleGet$Json } from '../fn/applications/v-4-applications-vehicle-get-json';
import { V4ApplicationsVehicleGet$Json$Params } from '../fn/applications/v-4-applications-vehicle-get-json';
import { v4ApplicationsVehicleGet$Plain } from '../fn/applications/v-4-applications-vehicle-get-plain';
import { V4ApplicationsVehicleGet$Plain$Params } from '../fn/applications/v-4-applications-vehicle-get-plain';
import { v4ApplicationsVehicleGet$Xml } from '../fn/applications/v-4-applications-vehicle-get-xml';
import { V4ApplicationsVehicleGet$Xml$Params } from '../fn/applications/v-4-applications-vehicle-get-xml';
import { v4CustomersAdminAppNotificationsPost$Json } from '../fn/applications/v-4-customers-admin-app-notifications-post-json';
import { V4CustomersAdminAppNotificationsPost$Json$Params } from '../fn/applications/v-4-customers-admin-app-notifications-post-json';
import { v4CustomersAdminAppNotificationsPost$Xml } from '../fn/applications/v-4-customers-admin-app-notifications-post-xml';
import { V4CustomersAdminAppNotificationsPost$Xml$Params } from '../fn/applications/v-4-customers-admin-app-notifications-post-xml';

@Injectable({ providedIn: 'root' })
export class ApplicationsService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `v4ApplicationsApplicationIdVehicleGet()` */
  static readonly V4ApplicationsApplicationIdVehicleGetPath = '/v4/applications/{applicationId}/vehicle';

  /**
   * Gets a vehicle.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `v4ApplicationsApplicationIdVehicleGet$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  v4ApplicationsApplicationIdVehicleGet$Plain$Response(params: V4ApplicationsApplicationIdVehicleGet$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<ModelsV4VehicleDtoVehicleBaseResponse>> {
    return v4ApplicationsApplicationIdVehicleGet$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * Gets a vehicle.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `v4ApplicationsApplicationIdVehicleGet$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  v4ApplicationsApplicationIdVehicleGet$Plain(params: V4ApplicationsApplicationIdVehicleGet$Plain$Params, context?: HttpContext): Observable<ModelsV4VehicleDtoVehicleBaseResponse> {
    return this.v4ApplicationsApplicationIdVehicleGet$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<ModelsV4VehicleDtoVehicleBaseResponse>): ModelsV4VehicleDtoVehicleBaseResponse => r.body)
    );
  }

  /**
   * Gets a vehicle.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `v4ApplicationsApplicationIdVehicleGet$Json()` instead.
   *
   * This method doesn't expect any request body.
   */
  v4ApplicationsApplicationIdVehicleGet$Json$Response(params: V4ApplicationsApplicationIdVehicleGet$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<ModelsV4VehicleDtoVehicleBaseResponse>> {
    return v4ApplicationsApplicationIdVehicleGet$Json(this.http, this.rootUrl, params, context);
  }

  /**
   * Gets a vehicle.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `v4ApplicationsApplicationIdVehicleGet$Json$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  v4ApplicationsApplicationIdVehicleGet$Json(params: V4ApplicationsApplicationIdVehicleGet$Json$Params, context?: HttpContext): Observable<ModelsV4VehicleDtoVehicleBaseResponse> {
    return this.v4ApplicationsApplicationIdVehicleGet$Json$Response(params, context).pipe(
      map((r: StrictHttpResponse<ModelsV4VehicleDtoVehicleBaseResponse>): ModelsV4VehicleDtoVehicleBaseResponse => r.body)
    );
  }

  /**
   * Gets a vehicle.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `v4ApplicationsApplicationIdVehicleGet$Xml()` instead.
   *
   * This method doesn't expect any request body.
   */
  v4ApplicationsApplicationIdVehicleGet$Xml$Response(params: V4ApplicationsApplicationIdVehicleGet$Xml$Params, context?: HttpContext): Observable<StrictHttpResponse<ModelsV4VehicleDtoVehicleBaseResponse>> {
    return v4ApplicationsApplicationIdVehicleGet$Xml(this.http, this.rootUrl, params, context);
  }

  /**
   * Gets a vehicle.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `v4ApplicationsApplicationIdVehicleGet$Xml$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  v4ApplicationsApplicationIdVehicleGet$Xml(params: V4ApplicationsApplicationIdVehicleGet$Xml$Params, context?: HttpContext): Observable<ModelsV4VehicleDtoVehicleBaseResponse> {
    return this.v4ApplicationsApplicationIdVehicleGet$Xml$Response(params, context).pipe(
      map((r: StrictHttpResponse<ModelsV4VehicleDtoVehicleBaseResponse>): ModelsV4VehicleDtoVehicleBaseResponse => r.body)
    );
  }

  /** Path part for operation `v4ApplicationsVehicleGet()` */
  static readonly V4ApplicationsVehicleGetPath = '/v4/applications/vehicle';

  /**
   * Gets a vehicle.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `v4ApplicationsVehicleGet$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  v4ApplicationsVehicleGet$Plain$Response(params: V4ApplicationsVehicleGet$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<ModelsV4VehicleDtoVehicleBaseResponse>> {
    return v4ApplicationsVehicleGet$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * Gets a vehicle.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `v4ApplicationsVehicleGet$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  v4ApplicationsVehicleGet$Plain(params: V4ApplicationsVehicleGet$Plain$Params, context?: HttpContext): Observable<ModelsV4VehicleDtoVehicleBaseResponse> {
    return this.v4ApplicationsVehicleGet$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<ModelsV4VehicleDtoVehicleBaseResponse>): ModelsV4VehicleDtoVehicleBaseResponse => r.body)
    );
  }

  /**
   * Gets a vehicle.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `v4ApplicationsVehicleGet$Json()` instead.
   *
   * This method doesn't expect any request body.
   */
  v4ApplicationsVehicleGet$Json$Response(params: V4ApplicationsVehicleGet$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<ModelsV4VehicleDtoVehicleBaseResponse>> {
    return v4ApplicationsVehicleGet$Json(this.http, this.rootUrl, params, context);
  }

  /**
   * Gets a vehicle.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `v4ApplicationsVehicleGet$Json$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  v4ApplicationsVehicleGet$Json(params: V4ApplicationsVehicleGet$Json$Params, context?: HttpContext): Observable<ModelsV4VehicleDtoVehicleBaseResponse> {
    return this.v4ApplicationsVehicleGet$Json$Response(params, context).pipe(
      map((r: StrictHttpResponse<ModelsV4VehicleDtoVehicleBaseResponse>): ModelsV4VehicleDtoVehicleBaseResponse => r.body)
    );
  }

  /**
   * Gets a vehicle.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `v4ApplicationsVehicleGet$Xml()` instead.
   *
   * This method doesn't expect any request body.
   */
  v4ApplicationsVehicleGet$Xml$Response(params: V4ApplicationsVehicleGet$Xml$Params, context?: HttpContext): Observable<StrictHttpResponse<ModelsV4VehicleDtoVehicleBaseResponse>> {
    return v4ApplicationsVehicleGet$Xml(this.http, this.rootUrl, params, context);
  }

  /**
   * Gets a vehicle.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `v4ApplicationsVehicleGet$Xml$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  v4ApplicationsVehicleGet$Xml(params: V4ApplicationsVehicleGet$Xml$Params, context?: HttpContext): Observable<ModelsV4VehicleDtoVehicleBaseResponse> {
    return this.v4ApplicationsVehicleGet$Xml$Response(params, context).pipe(
      map((r: StrictHttpResponse<ModelsV4VehicleDtoVehicleBaseResponse>): ModelsV4VehicleDtoVehicleBaseResponse => r.body)
    );
  }

  /** Path part for operation `v4ApplicationsApplicationIdNotifyDealerPost()` */
  static readonly V4ApplicationsApplicationIdNotifyDealerPostPath = '/v4/applications/{applicationId}/notify-dealer';

  /**
   * NotifyDealer.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `v4ApplicationsApplicationIdNotifyDealerPost()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  v4ApplicationsApplicationIdNotifyDealerPost$Response(params: V4ApplicationsApplicationIdNotifyDealerPost$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return v4ApplicationsApplicationIdNotifyDealerPost(this.http, this.rootUrl, params, context);
  }

  /**
   * NotifyDealer.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `v4ApplicationsApplicationIdNotifyDealerPost$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  v4ApplicationsApplicationIdNotifyDealerPost(params: V4ApplicationsApplicationIdNotifyDealerPost$Params, context?: HttpContext): Observable<void> {
    return this.v4ApplicationsApplicationIdNotifyDealerPost$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `v4ApplicationsApplicationIdInsuranceProductsPost()` */
  static readonly V4ApplicationsApplicationIdInsuranceProductsPostPath = '/v4/applications/{applicationId}/insurance/products';

  /**
   * Get vehicle insurance products.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `v4ApplicationsApplicationIdInsuranceProductsPost$Json$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  v4ApplicationsApplicationIdInsuranceProductsPost$Json$Plain$Response(params: V4ApplicationsApplicationIdInsuranceProductsPost$Json$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<ModelsV3InsuranceDtoInsuranceProductListBaseResponse>> {
    return v4ApplicationsApplicationIdInsuranceProductsPost$Json$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * Get vehicle insurance products.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `v4ApplicationsApplicationIdInsuranceProductsPost$Json$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  v4ApplicationsApplicationIdInsuranceProductsPost$Json$Plain(params: V4ApplicationsApplicationIdInsuranceProductsPost$Json$Plain$Params, context?: HttpContext): Observable<ModelsV3InsuranceDtoInsuranceProductListBaseResponse> {
    return this.v4ApplicationsApplicationIdInsuranceProductsPost$Json$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<ModelsV3InsuranceDtoInsuranceProductListBaseResponse>): ModelsV3InsuranceDtoInsuranceProductListBaseResponse => r.body)
    );
  }

  /**
   * Get vehicle insurance products.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `v4ApplicationsApplicationIdInsuranceProductsPost$Json$Json()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  v4ApplicationsApplicationIdInsuranceProductsPost$Json$Json$Response(params: V4ApplicationsApplicationIdInsuranceProductsPost$Json$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<ModelsV3InsuranceDtoInsuranceProductListBaseResponse>> {
    return v4ApplicationsApplicationIdInsuranceProductsPost$Json$Json(this.http, this.rootUrl, params, context);
  }

  /**
   * Get vehicle insurance products.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `v4ApplicationsApplicationIdInsuranceProductsPost$Json$Json$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  v4ApplicationsApplicationIdInsuranceProductsPost$Json$Json(params: V4ApplicationsApplicationIdInsuranceProductsPost$Json$Json$Params, context?: HttpContext): Observable<ModelsV3InsuranceDtoInsuranceProductListBaseResponse> {
    return this.v4ApplicationsApplicationIdInsuranceProductsPost$Json$Json$Response(params, context).pipe(
      map((r: StrictHttpResponse<ModelsV3InsuranceDtoInsuranceProductListBaseResponse>): ModelsV3InsuranceDtoInsuranceProductListBaseResponse => r.body)
    );
  }

  /**
   * Get vehicle insurance products.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `v4ApplicationsApplicationIdInsuranceProductsPost$Json$Xml()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  v4ApplicationsApplicationIdInsuranceProductsPost$Json$Xml$Response(params: V4ApplicationsApplicationIdInsuranceProductsPost$Json$Xml$Params, context?: HttpContext): Observable<StrictHttpResponse<ModelsV3InsuranceDtoInsuranceProductListBaseResponse>> {
    return v4ApplicationsApplicationIdInsuranceProductsPost$Json$Xml(this.http, this.rootUrl, params, context);
  }

  /**
   * Get vehicle insurance products.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `v4ApplicationsApplicationIdInsuranceProductsPost$Json$Xml$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  v4ApplicationsApplicationIdInsuranceProductsPost$Json$Xml(params: V4ApplicationsApplicationIdInsuranceProductsPost$Json$Xml$Params, context?: HttpContext): Observable<ModelsV3InsuranceDtoInsuranceProductListBaseResponse> {
    return this.v4ApplicationsApplicationIdInsuranceProductsPost$Json$Xml$Response(params, context).pipe(
      map((r: StrictHttpResponse<ModelsV3InsuranceDtoInsuranceProductListBaseResponse>): ModelsV3InsuranceDtoInsuranceProductListBaseResponse => r.body)
    );
  }

  /**
   * Get vehicle insurance products.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `v4ApplicationsApplicationIdInsuranceProductsPost$Xml$Plain()` instead.
   *
   * This method sends `application/*+xml` and handles request body of type `application/*+xml`.
   */
  v4ApplicationsApplicationIdInsuranceProductsPost$Xml$Plain$Response(params: V4ApplicationsApplicationIdInsuranceProductsPost$Xml$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<ModelsV3InsuranceDtoInsuranceProductListBaseResponse>> {
    return v4ApplicationsApplicationIdInsuranceProductsPost$Xml$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * Get vehicle insurance products.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `v4ApplicationsApplicationIdInsuranceProductsPost$Xml$Plain$Response()` instead.
   *
   * This method sends `application/*+xml` and handles request body of type `application/*+xml`.
   */
  v4ApplicationsApplicationIdInsuranceProductsPost$Xml$Plain(params: V4ApplicationsApplicationIdInsuranceProductsPost$Xml$Plain$Params, context?: HttpContext): Observable<ModelsV3InsuranceDtoInsuranceProductListBaseResponse> {
    return this.v4ApplicationsApplicationIdInsuranceProductsPost$Xml$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<ModelsV3InsuranceDtoInsuranceProductListBaseResponse>): ModelsV3InsuranceDtoInsuranceProductListBaseResponse => r.body)
    );
  }

  /**
   * Get vehicle insurance products.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `v4ApplicationsApplicationIdInsuranceProductsPost$Xml$Json()` instead.
   *
   * This method sends `application/*+xml` and handles request body of type `application/*+xml`.
   */
  v4ApplicationsApplicationIdInsuranceProductsPost$Xml$Json$Response(params: V4ApplicationsApplicationIdInsuranceProductsPost$Xml$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<ModelsV3InsuranceDtoInsuranceProductListBaseResponse>> {
    return v4ApplicationsApplicationIdInsuranceProductsPost$Xml$Json(this.http, this.rootUrl, params, context);
  }

  /**
   * Get vehicle insurance products.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `v4ApplicationsApplicationIdInsuranceProductsPost$Xml$Json$Response()` instead.
   *
   * This method sends `application/*+xml` and handles request body of type `application/*+xml`.
   */
  v4ApplicationsApplicationIdInsuranceProductsPost$Xml$Json(params: V4ApplicationsApplicationIdInsuranceProductsPost$Xml$Json$Params, context?: HttpContext): Observable<ModelsV3InsuranceDtoInsuranceProductListBaseResponse> {
    return this.v4ApplicationsApplicationIdInsuranceProductsPost$Xml$Json$Response(params, context).pipe(
      map((r: StrictHttpResponse<ModelsV3InsuranceDtoInsuranceProductListBaseResponse>): ModelsV3InsuranceDtoInsuranceProductListBaseResponse => r.body)
    );
  }

  /**
   * Get vehicle insurance products.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `v4ApplicationsApplicationIdInsuranceProductsPost$Xml$Xml()` instead.
   *
   * This method sends `application/*+xml` and handles request body of type `application/*+xml`.
   */
  v4ApplicationsApplicationIdInsuranceProductsPost$Xml$Xml$Response(params: V4ApplicationsApplicationIdInsuranceProductsPost$Xml$Xml$Params, context?: HttpContext): Observable<StrictHttpResponse<ModelsV3InsuranceDtoInsuranceProductListBaseResponse>> {
    return v4ApplicationsApplicationIdInsuranceProductsPost$Xml$Xml(this.http, this.rootUrl, params, context);
  }

  /**
   * Get vehicle insurance products.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `v4ApplicationsApplicationIdInsuranceProductsPost$Xml$Xml$Response()` instead.
   *
   * This method sends `application/*+xml` and handles request body of type `application/*+xml`.
   */
  v4ApplicationsApplicationIdInsuranceProductsPost$Xml$Xml(params: V4ApplicationsApplicationIdInsuranceProductsPost$Xml$Xml$Params, context?: HttpContext): Observable<ModelsV3InsuranceDtoInsuranceProductListBaseResponse> {
    return this.v4ApplicationsApplicationIdInsuranceProductsPost$Xml$Xml$Response(params, context).pipe(
      map((r: StrictHttpResponse<ModelsV3InsuranceDtoInsuranceProductListBaseResponse>): ModelsV3InsuranceDtoInsuranceProductListBaseResponse => r.body)
    );
  }

  /** Path part for operation `v4ApplicationsApplicationIdInsuranceQuotePost()` */
  static readonly V4ApplicationsApplicationIdInsuranceQuotePostPath = '/v4/applications/{applicationId}/insurance/quote';

  /**
   * GetQuote.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `v4ApplicationsApplicationIdInsuranceQuotePost$Json$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  v4ApplicationsApplicationIdInsuranceQuotePost$Json$Plain$Response(params: V4ApplicationsApplicationIdInsuranceQuotePost$Json$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<ModelsV3ApplicationApplicationQuoteResponseBaseResponse>> {
    return v4ApplicationsApplicationIdInsuranceQuotePost$Json$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * GetQuote.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `v4ApplicationsApplicationIdInsuranceQuotePost$Json$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  v4ApplicationsApplicationIdInsuranceQuotePost$Json$Plain(params: V4ApplicationsApplicationIdInsuranceQuotePost$Json$Plain$Params, context?: HttpContext): Observable<ModelsV3ApplicationApplicationQuoteResponseBaseResponse> {
    return this.v4ApplicationsApplicationIdInsuranceQuotePost$Json$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<ModelsV3ApplicationApplicationQuoteResponseBaseResponse>): ModelsV3ApplicationApplicationQuoteResponseBaseResponse => r.body)
    );
  }

  /**
   * GetQuote.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `v4ApplicationsApplicationIdInsuranceQuotePost$Json$Json()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  v4ApplicationsApplicationIdInsuranceQuotePost$Json$Json$Response(params: V4ApplicationsApplicationIdInsuranceQuotePost$Json$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<ModelsV3ApplicationApplicationQuoteResponseBaseResponse>> {
    return v4ApplicationsApplicationIdInsuranceQuotePost$Json$Json(this.http, this.rootUrl, params, context);
  }

  /**
   * GetQuote.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `v4ApplicationsApplicationIdInsuranceQuotePost$Json$Json$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  v4ApplicationsApplicationIdInsuranceQuotePost$Json$Json(params: V4ApplicationsApplicationIdInsuranceQuotePost$Json$Json$Params, context?: HttpContext): Observable<ModelsV3ApplicationApplicationQuoteResponseBaseResponse> {
    return this.v4ApplicationsApplicationIdInsuranceQuotePost$Json$Json$Response(params, context).pipe(
      map((r: StrictHttpResponse<ModelsV3ApplicationApplicationQuoteResponseBaseResponse>): ModelsV3ApplicationApplicationQuoteResponseBaseResponse => r.body)
    );
  }

  /**
   * GetQuote.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `v4ApplicationsApplicationIdInsuranceQuotePost$Json$Xml()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  v4ApplicationsApplicationIdInsuranceQuotePost$Json$Xml$Response(params: V4ApplicationsApplicationIdInsuranceQuotePost$Json$Xml$Params, context?: HttpContext): Observable<StrictHttpResponse<ModelsV3ApplicationApplicationQuoteResponseBaseResponse>> {
    return v4ApplicationsApplicationIdInsuranceQuotePost$Json$Xml(this.http, this.rootUrl, params, context);
  }

  /**
   * GetQuote.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `v4ApplicationsApplicationIdInsuranceQuotePost$Json$Xml$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  v4ApplicationsApplicationIdInsuranceQuotePost$Json$Xml(params: V4ApplicationsApplicationIdInsuranceQuotePost$Json$Xml$Params, context?: HttpContext): Observable<ModelsV3ApplicationApplicationQuoteResponseBaseResponse> {
    return this.v4ApplicationsApplicationIdInsuranceQuotePost$Json$Xml$Response(params, context).pipe(
      map((r: StrictHttpResponse<ModelsV3ApplicationApplicationQuoteResponseBaseResponse>): ModelsV3ApplicationApplicationQuoteResponseBaseResponse => r.body)
    );
  }

  /**
   * GetQuote.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `v4ApplicationsApplicationIdInsuranceQuotePost$Xml$Plain()` instead.
   *
   * This method sends `application/*+xml` and handles request body of type `application/*+xml`.
   */
  v4ApplicationsApplicationIdInsuranceQuotePost$Xml$Plain$Response(params: V4ApplicationsApplicationIdInsuranceQuotePost$Xml$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<ModelsV3ApplicationApplicationQuoteResponseBaseResponse>> {
    return v4ApplicationsApplicationIdInsuranceQuotePost$Xml$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * GetQuote.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `v4ApplicationsApplicationIdInsuranceQuotePost$Xml$Plain$Response()` instead.
   *
   * This method sends `application/*+xml` and handles request body of type `application/*+xml`.
   */
  v4ApplicationsApplicationIdInsuranceQuotePost$Xml$Plain(params: V4ApplicationsApplicationIdInsuranceQuotePost$Xml$Plain$Params, context?: HttpContext): Observable<ModelsV3ApplicationApplicationQuoteResponseBaseResponse> {
    return this.v4ApplicationsApplicationIdInsuranceQuotePost$Xml$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<ModelsV3ApplicationApplicationQuoteResponseBaseResponse>): ModelsV3ApplicationApplicationQuoteResponseBaseResponse => r.body)
    );
  }

  /**
   * GetQuote.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `v4ApplicationsApplicationIdInsuranceQuotePost$Xml$Json()` instead.
   *
   * This method sends `application/*+xml` and handles request body of type `application/*+xml`.
   */
  v4ApplicationsApplicationIdInsuranceQuotePost$Xml$Json$Response(params: V4ApplicationsApplicationIdInsuranceQuotePost$Xml$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<ModelsV3ApplicationApplicationQuoteResponseBaseResponse>> {
    return v4ApplicationsApplicationIdInsuranceQuotePost$Xml$Json(this.http, this.rootUrl, params, context);
  }

  /**
   * GetQuote.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `v4ApplicationsApplicationIdInsuranceQuotePost$Xml$Json$Response()` instead.
   *
   * This method sends `application/*+xml` and handles request body of type `application/*+xml`.
   */
  v4ApplicationsApplicationIdInsuranceQuotePost$Xml$Json(params: V4ApplicationsApplicationIdInsuranceQuotePost$Xml$Json$Params, context?: HttpContext): Observable<ModelsV3ApplicationApplicationQuoteResponseBaseResponse> {
    return this.v4ApplicationsApplicationIdInsuranceQuotePost$Xml$Json$Response(params, context).pipe(
      map((r: StrictHttpResponse<ModelsV3ApplicationApplicationQuoteResponseBaseResponse>): ModelsV3ApplicationApplicationQuoteResponseBaseResponse => r.body)
    );
  }

  /**
   * GetQuote.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `v4ApplicationsApplicationIdInsuranceQuotePost$Xml$Xml()` instead.
   *
   * This method sends `application/*+xml` and handles request body of type `application/*+xml`.
   */
  v4ApplicationsApplicationIdInsuranceQuotePost$Xml$Xml$Response(params: V4ApplicationsApplicationIdInsuranceQuotePost$Xml$Xml$Params, context?: HttpContext): Observable<StrictHttpResponse<ModelsV3ApplicationApplicationQuoteResponseBaseResponse>> {
    return v4ApplicationsApplicationIdInsuranceQuotePost$Xml$Xml(this.http, this.rootUrl, params, context);
  }

  /**
   * GetQuote.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `v4ApplicationsApplicationIdInsuranceQuotePost$Xml$Xml$Response()` instead.
   *
   * This method sends `application/*+xml` and handles request body of type `application/*+xml`.
   */
  v4ApplicationsApplicationIdInsuranceQuotePost$Xml$Xml(params: V4ApplicationsApplicationIdInsuranceQuotePost$Xml$Xml$Params, context?: HttpContext): Observable<ModelsV3ApplicationApplicationQuoteResponseBaseResponse> {
    return this.v4ApplicationsApplicationIdInsuranceQuotePost$Xml$Xml$Response(params, context).pipe(
      map((r: StrictHttpResponse<ModelsV3ApplicationApplicationQuoteResponseBaseResponse>): ModelsV3ApplicationApplicationQuoteResponseBaseResponse => r.body)
    );
  }

  /** Path part for operation `v4ApplicationsApplicationIdPut()` */
  static readonly V4ApplicationsApplicationIdPutPath = '/v4/applications/{applicationId}';

  /**
   * Sync application.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `v4ApplicationsApplicationIdPut$Json$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  v4ApplicationsApplicationIdPut$Json$Plain$Response(params: V4ApplicationsApplicationIdPut$Json$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<ModelsV3ApplicationApplicationSyncRequestBaseResponse>> {
    return v4ApplicationsApplicationIdPut$Json$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * Sync application.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `v4ApplicationsApplicationIdPut$Json$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  v4ApplicationsApplicationIdPut$Json$Plain(params: V4ApplicationsApplicationIdPut$Json$Plain$Params, context?: HttpContext): Observable<ModelsV3ApplicationApplicationSyncRequestBaseResponse> {
    return this.v4ApplicationsApplicationIdPut$Json$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<ModelsV3ApplicationApplicationSyncRequestBaseResponse>): ModelsV3ApplicationApplicationSyncRequestBaseResponse => r.body)
    );
  }

  /**
   * Sync application.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `v4ApplicationsApplicationIdPut$Json$Json()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  v4ApplicationsApplicationIdPut$Json$Json$Response(params: V4ApplicationsApplicationIdPut$Json$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<ModelsV3ApplicationApplicationSyncRequestBaseResponse>> {
    return v4ApplicationsApplicationIdPut$Json$Json(this.http, this.rootUrl, params, context);
  }

  /**
   * Sync application.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `v4ApplicationsApplicationIdPut$Json$Json$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  v4ApplicationsApplicationIdPut$Json$Json(params: V4ApplicationsApplicationIdPut$Json$Json$Params, context?: HttpContext): Observable<ModelsV3ApplicationApplicationSyncRequestBaseResponse> {
    return this.v4ApplicationsApplicationIdPut$Json$Json$Response(params, context).pipe(
      map((r: StrictHttpResponse<ModelsV3ApplicationApplicationSyncRequestBaseResponse>): ModelsV3ApplicationApplicationSyncRequestBaseResponse => r.body)
    );
  }

  /**
   * Sync application.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `v4ApplicationsApplicationIdPut$Json$Xml()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  v4ApplicationsApplicationIdPut$Json$Xml$Response(params: V4ApplicationsApplicationIdPut$Json$Xml$Params, context?: HttpContext): Observable<StrictHttpResponse<ModelsV3ApplicationApplicationSyncRequestBaseResponse>> {
    return v4ApplicationsApplicationIdPut$Json$Xml(this.http, this.rootUrl, params, context);
  }

  /**
   * Sync application.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `v4ApplicationsApplicationIdPut$Json$Xml$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  v4ApplicationsApplicationIdPut$Json$Xml(params: V4ApplicationsApplicationIdPut$Json$Xml$Params, context?: HttpContext): Observable<ModelsV3ApplicationApplicationSyncRequestBaseResponse> {
    return this.v4ApplicationsApplicationIdPut$Json$Xml$Response(params, context).pipe(
      map((r: StrictHttpResponse<ModelsV3ApplicationApplicationSyncRequestBaseResponse>): ModelsV3ApplicationApplicationSyncRequestBaseResponse => r.body)
    );
  }

  /**
   * Sync application.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `v4ApplicationsApplicationIdPut$Xml$Plain()` instead.
   *
   * This method sends `application/*+xml` and handles request body of type `application/*+xml`.
   */
  v4ApplicationsApplicationIdPut$Xml$Plain$Response(params: V4ApplicationsApplicationIdPut$Xml$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<ModelsV3ApplicationApplicationSyncRequestBaseResponse>> {
    return v4ApplicationsApplicationIdPut$Xml$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * Sync application.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `v4ApplicationsApplicationIdPut$Xml$Plain$Response()` instead.
   *
   * This method sends `application/*+xml` and handles request body of type `application/*+xml`.
   */
  v4ApplicationsApplicationIdPut$Xml$Plain(params: V4ApplicationsApplicationIdPut$Xml$Plain$Params, context?: HttpContext): Observable<ModelsV3ApplicationApplicationSyncRequestBaseResponse> {
    return this.v4ApplicationsApplicationIdPut$Xml$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<ModelsV3ApplicationApplicationSyncRequestBaseResponse>): ModelsV3ApplicationApplicationSyncRequestBaseResponse => r.body)
    );
  }

  /**
   * Sync application.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `v4ApplicationsApplicationIdPut$Xml$Json()` instead.
   *
   * This method sends `application/*+xml` and handles request body of type `application/*+xml`.
   */
  v4ApplicationsApplicationIdPut$Xml$Json$Response(params: V4ApplicationsApplicationIdPut$Xml$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<ModelsV3ApplicationApplicationSyncRequestBaseResponse>> {
    return v4ApplicationsApplicationIdPut$Xml$Json(this.http, this.rootUrl, params, context);
  }

  /**
   * Sync application.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `v4ApplicationsApplicationIdPut$Xml$Json$Response()` instead.
   *
   * This method sends `application/*+xml` and handles request body of type `application/*+xml`.
   */
  v4ApplicationsApplicationIdPut$Xml$Json(params: V4ApplicationsApplicationIdPut$Xml$Json$Params, context?: HttpContext): Observable<ModelsV3ApplicationApplicationSyncRequestBaseResponse> {
    return this.v4ApplicationsApplicationIdPut$Xml$Json$Response(params, context).pipe(
      map((r: StrictHttpResponse<ModelsV3ApplicationApplicationSyncRequestBaseResponse>): ModelsV3ApplicationApplicationSyncRequestBaseResponse => r.body)
    );
  }

  /**
   * Sync application.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `v4ApplicationsApplicationIdPut$Xml$Xml()` instead.
   *
   * This method sends `application/*+xml` and handles request body of type `application/*+xml`.
   */
  v4ApplicationsApplicationIdPut$Xml$Xml$Response(params: V4ApplicationsApplicationIdPut$Xml$Xml$Params, context?: HttpContext): Observable<StrictHttpResponse<ModelsV3ApplicationApplicationSyncRequestBaseResponse>> {
    return v4ApplicationsApplicationIdPut$Xml$Xml(this.http, this.rootUrl, params, context);
  }

  /**
   * Sync application.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `v4ApplicationsApplicationIdPut$Xml$Xml$Response()` instead.
   *
   * This method sends `application/*+xml` and handles request body of type `application/*+xml`.
   */
  v4ApplicationsApplicationIdPut$Xml$Xml(params: V4ApplicationsApplicationIdPut$Xml$Xml$Params, context?: HttpContext): Observable<ModelsV3ApplicationApplicationSyncRequestBaseResponse> {
    return this.v4ApplicationsApplicationIdPut$Xml$Xml$Response(params, context).pipe(
      map((r: StrictHttpResponse<ModelsV3ApplicationApplicationSyncRequestBaseResponse>): ModelsV3ApplicationApplicationSyncRequestBaseResponse => r.body)
    );
  }

  /** Path part for operation `v4CustomersAdminAppNotificationsPost()` */
  static readonly V4CustomersAdminAppNotificationsPostPath = '/v4/customers-admin/app-notifications';

  /**
   * Creates a notification for a given client ID.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `v4CustomersAdminAppNotificationsPost$Json()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  v4CustomersAdminAppNotificationsPost$Json$Response(params?: V4CustomersAdminAppNotificationsPost$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return v4CustomersAdminAppNotificationsPost$Json(this.http, this.rootUrl, params, context);
  }

  /**
   * Creates a notification for a given client ID.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `v4CustomersAdminAppNotificationsPost$Json$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  v4CustomersAdminAppNotificationsPost$Json(params?: V4CustomersAdminAppNotificationsPost$Json$Params, context?: HttpContext): Observable<void> {
    return this.v4CustomersAdminAppNotificationsPost$Json$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /**
   * Creates a notification for a given client ID.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `v4CustomersAdminAppNotificationsPost$Xml()` instead.
   *
   * This method sends `application/*+xml` and handles request body of type `application/*+xml`.
   */
  v4CustomersAdminAppNotificationsPost$Xml$Response(params?: V4CustomersAdminAppNotificationsPost$Xml$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return v4CustomersAdminAppNotificationsPost$Xml(this.http, this.rootUrl, params, context);
  }

  /**
   * Creates a notification for a given client ID.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `v4CustomersAdminAppNotificationsPost$Xml$Response()` instead.
   *
   * This method sends `application/*+xml` and handles request body of type `application/*+xml`.
   */
  v4CustomersAdminAppNotificationsPost$Xml(params?: V4CustomersAdminAppNotificationsPost$Xml$Params, context?: HttpContext): Observable<void> {
    return this.v4CustomersAdminAppNotificationsPost$Xml$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

}
